
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
     import { Cliente } from '@/__env/lib/Clientes';
    import actual from './estadisticas-cliente-actual.vue'
    import ventas from './estadisticas-cliente-ventas.vue'
    import articulos from './estadisticas-cliente-articulos.vue'
    @Component( {
        name: "Componente",
        props: {},
        components: {
            actual,
            ventas,
            articulos,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public tab: string = '';
        public Estado: 'ok' | 'cargando' = 'cargando';
        Cliente: Cliente = new Cliente()

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Eventos.push( this.Controlador.onActualizarFavoritos.subscribe( () => this.Refrescar() ) );
            this.Cliente = this.Controlador.ClienteSeleccionado;
            this.Estado = "ok";
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => { this.Refresh = true; } );
        }

    }
